/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 出荷数量7
 * @export
 * @interface Col7
 */
export interface Col7 {
}

/**
 * Check if a given object implements the Col7 interface.
 */
export function instanceOfCol7(value: object): value is Col7 {
    return true;
}

export function Col7FromJSON(json: any): Col7 {
    return Col7FromJSONTyped(json, false);
}

export function Col7FromJSONTyped(json: any, ignoreDiscriminator: boolean): Col7 {
    return json;
}

export function Col7ToJSON(json: any): Col7 {
    return Col7ToJSONTyped(json, false);
}

export function Col7ToJSONTyped(value?: Col7 | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

